import {
  StyleSheet,
  Text,
  View,
  Dimensions,
  TouchableNativeFeedback,
  Image,
} from "react-native";
import React from "react";
import dayjs from "dayjs";

import { CX_PAGE_NAME_CLICKED } from "@constants/analyticsEvents";
import analytics from "@services/analytics";
import t from "@constants/localization";
import colors from "@constants/color";
import ChevronRight from "@assets/svg/ChevronRight";
import { ConnectedByCM } from "../../components";

const PATH = "screens/Shop/TodaysCustomers/components/CustomerCard";

const NewTag = () => {
  return (
    <View style={styles.newTag}>
      <Text style={styles.newTagText}>नया</Text>
    </View>
  );
};

const customerCard = (props) => {
  const { navigation, data } = props;
  const {
    user_id,
    name,
    total_orders,
    is_connected_by_cm,
    isNew,
    last_order_date,
    lastOrdered,
    wallet_balance,
  } = data;

  const sendCxClicks = (name) => {
    navigation.navigate("CustomerProfile", {
      user: { user_id },
      fetchProfile: true,
    });
    analytics.trackEvent(CX_PAGE_NAME_CLICKED, {
      screen: "todays_cx",
      name,
      Order_recency: last_order_date,
    });
  };

  return (
    <TouchableNativeFeedback
      background={TouchableNativeFeedback.Ripple("rgba(0, 0, 0, 0.05)")}
      onPress={() => sendCxClicks(name)}
    >
      <View style={styles.container}>
        {isNew && <NewTag />}
        <View style={styles.nameContainer}>
          <Text style={[styles.name, { marginRight: 6 }]}>{name}</Text>
          <ConnectedByCM show={is_connected_by_cm} />
        </View>
        <View style={styles.cardDesc}>
          {total_orders?.total_orders > 0 ? (
            <View style={{ flexDirection: "row" }}>
              <Text style={styles.orderDesc}>
                {t(`${PATH}/order`)}
                <Text
                  style={{
                    fontWeight: "bold",
                    color: colors.plain_green,
                  }}
                >
                  {total_orders?.total_sales !== null
                    ? total_orders?.total_sales.toFixed(2)
                    : 0}
                </Text>
              </Text>
            </View>
          ) : (
            <View>
              {last_order_date ? (
                <Text style={styles.orderDesc}>
                  {t(`${PATH}/lastOrder`)}
                  <Text style={{ fontFamily: "NotoSansDevanagari-Bold" }}>
                    {dayjs().diff(last_order_date, "days") < 31
                      ? t(`${PATH}/days`, { days: lastOrdered })
                      : t(`${PATH}/months`, {
                          months: dayjs().diff(last_order_date, "months"),
                        })}
                  </Text>
                </Text>
              ) : (
                <Text style={[styles.orderDesc, { color: colors.plain_red }]}>
                  {t(`${PATH}/noOrders`)}
                </Text>
              )}
            </View>
          )}
          <View style={styles.iconContainer}>
            {wallet_balance ? (
              <View style={styles.iconContainer}>
                <Image
                  source={{
                    uri: "https://pub-storage-svc.citymall.live/1653480625108Wallet%20Amount.png",
                  }}
                  style={{
                    height: 24,
                    width: 24,
                  }}
                />
                <Text style={styles.walletBalance}>{wallet_balance}</Text>
              </View>
            ) : null}
            <View style={{ height: 12, width: 12 }}>
              <ChevronRight pathFill="rgba(0,0,0,0.4)" />
            </View>
          </View>
        </View>
      </View>
    </TouchableNativeFeedback>
  );
};

export default customerCard;

const styles = StyleSheet.create({
  newTagText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontWeight: "700",
    fontSize: 11,
    color: "#FFFFFF",
    textAlign: "center",
  },
  newTag: {
    position: "absolute",
    left: -20,
    top: 5,
    height: 15,
    width: 60,
    alignItems: "center",
    justifyContent: "center",
    transform: [{ rotate: "-45deg" }],
    backgroundColor: "#00BA6E",
  },
  container: {
    justifyContent: "space-between",
    backgroundColor: "white",
    width: Dimensions.get("window").width,
    borderRadius: 6,
    borderBottomWidth: 1,
    borderBottomColor: "#F4F4F4",
    overflow: "hidden",
    paddingTop: 8,
    paddingBottom: 16,
    paddingHorizontal: 16,
    position: "relative",
  },
  nameContainer: {
    flexDirection: "row",
    paddingBottom: 2,
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
    height: 34,
  },
  name: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: "900",
    fontFamily: "NotoSansDevanagari-Bold",
    color: "rgba(0, 0, 0, 0.86)",
    textAlign: "left",
    alignSelf: "flex-end",
  },
  orderDesc: {
    fontSize: 14,
    lineHeight: 20,
    fontFamily: "NotoSansDevanagari-Regular",
    color: colors.lightBlack,
  },
  verticalSeparator: {
    marginHorizontal: 8,
    fontSize: 12,
    color: colors.lightMediumBlack,
  },
  cardDesc: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 4,
  },
  walletBalance: {
    fontSize: 16,
    lineHeight: 30,
    fontFamily: "NotoSansDevanagari-Bold",
    marginHorizontal: 4,
  },
  iconContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
});
